<template lang="html">
  <div id="blog-page">
    <section class="container oversized-container articles-section">
      <div class="row">
        <div class="col-12 mb-3 col-page-title">
          <h2 class="title-s1 c-primary">Blog</h2>
        </div>

        <div class="col-12 col-md-6 col-lg-4 col-xl-3 col-article article-sample-1" v-for="(blog, ahInx) in blogs" :key="'ahInx-'+ahInx">
          <router-link class="t-250 placed-backg article-link" v-bind:style="{ backgroundImage: 'url('+blog.imageUrl+')' }" :to="'/blog/'+$root._converToURL(blog.title, blog.id)" style="background-size: contain;">
            <img class="empty" src="public/images/pages/blog/article.png">

            <div class="inside">
              <div class="t-250 show">Ver más</div>
              <div class="shadow"></div>
              <div class="box-txt">
                <h5>{{blog.title}}</h5>
                <h6>{{blog.date}}</h6>

                <!-- <div class="descr">
                  <p>
                    Descripción breve del comunicado para pactar el interés del usuario.
                  </p>
                </div> -->
              </div>
            </div>
          </router-link>
        </div>
        <sweet-modal blocking hide-close-button ref="modalloading">
        <div class="fa-3x" ><i class="fas fa-spinner fa-pulse"></i></div><br/>
        <div>Cargando ...</div>
      </sweet-modal>
      </div>
     
    </section>
  </div>
</template>

<script>
export default {
  data(){
    return{
      blogs: [],
      
    }
  },

  methods: {
    getRows: function(){
      this.$refs.modalloading.open();
      axios.get(tools.url('/api/blogs')).then((response)=>{
          this.blogs = response.data;
          this.$refs.modalloading.close();
      });
    }
  },

  mounted(){
     this.getRows();
  },
}
</script>
